// extracted by mini-css-extract-plugin
export default {"card":"FgTfA","pretitle":"dBtOv","title":"QkK9I","percentage":"_6TZNV","pie":"YXVsF"};